
import React from 'react';
import '../../../app/app.scss';
import { translate } from 'react-jhipster';

export const InternalServerError = (props) => {
  const error = props.error;
  return (
    <div className="error-page" >
      <div className="row justify-content-center">
        <div className="col-md-6">
          <p className="error-page-title">
            {translate('form.errors.messages.errorPageTitle')}
          </p>
          <p className="error-page-subtitle">
            {translate('form.errors.messages.errorPageSubTitle')}
          </p>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-6">
          <img className="align-middle" src="content/images/illu_oups.svg" />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-6">
          <p className="_text">
            {translate('form.errors.messages.errorText')}
          </p>
        </div>
      </div>
      {process.env.NODE_ENV === 'development' ? (
        <>
          <br />
          <p className="_message">{error?.type}</p>
          {error?.message}
          {error.details &&
            <details className="_details_error">
              {error.details.join(' / ')}
            </details>
          }
        </>
      ) : undefined}
    </div>
  );
};

export default InternalServerError;
